import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface MakeupSettings {
  makeupEnabled: boolean;
  allowParentMakeupBooking: boolean;
  defaultFamilyMakeupCredits: number;
  defaultStudentMakeupAllotment: number;
  makeupExpirationDays: number;
  makeupConfirmationEmailEnabled: boolean;
}

export const getMakeupSettingsAPI = async () => {
  const response = await baseAPI.get<MakeupSettings>('/makeup/settings');
  return response.data;
};

export const useGetMakeupSettings = () => {
  return useQuery({
    queryKey: [KEYS.MAKEUP_SETTINGS],
    queryFn: () => getMakeupSettingsAPI(),
  });
};
